module.exports = __webpack_public_path__ + "images/emoji/high_heel.734de6435706f5ed069b.png";